import { InjectionToken } from '@angular/core';
import { ModalRef } from '@ecs-services/modal/modal-ref';

export const MODAL_TOKEN = new InjectionToken<ModalRef<any>>('ModalWrapper');
export const MODAL_CONTENT_TOKEN = new InjectionToken<InjectionData<any, any>>('ModalContent');

/**
 * Data that gets injected into a component
 *
 * **IMPORTANT**: Has to be the _first_ constructor parameter of the component class
 */
export type InjectionData<Input, Output = never> = {
    data?: Input;
    close: (returnData?: Output) => void;
};

export type Constructor = new (...args: any[]) => any;
type FirstParameter<F extends Constructor> = ConstructorParameters<F>[0];

/**
 * Type of data that gets injected with InjectionData
 */
export type ClassInjectionData<F extends Constructor> = FirstParameter<F> extends InjectionData<infer Input>
    ? Input
    : never;

/**
 * Type of data that gets returned when a modal closes
 */
export type ModalReturnType<F extends Constructor> =
    | (FirstParameter<F> extends InjectionData<any, infer Output> ? Output : never)
    | null;

export interface ModalConfiguration {
    type: string;
    headline: string;
    label: string;
    status: string;
    open: boolean;
    size: string;
    closeButton: boolean;
}

export interface ModalWrapper<C extends Constructor> {
    component: C;
    configuration: ModalConfiguration;
    data?: ClassInjectionData<C>;
}
